// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"65cf813e","375":"656abc31","396":"87ade210","955":"679ce7d3"}[chunkId] + ".chunk.css";
};